<template>
  <Modal :activeModal="isActiveModal" @closeModal="closeModal" :widthModal="600">
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
          {{ $t('jogadores.modalMotivoExclusao.title') }}
          <v-spacer></v-spacer>
          <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <div class="box-form box-form-products">
        <v-form>
          <v-card-text class="modal-cadastro-form">
            <v-card-title>
            {{ entity.jsonData.fullName }}
            </v-card-title>
            <v-row>
              <v-col cols="12" class="modal-cadastro-form-col-imput">
                <v-select 
                  v-model="motivoExclusao"
                  :items="itemsSelectMotivoExclusao"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" class="modal-cadastro-form-col-imput" v-if="motivoExclusao === 'Outros'">
                <v-textarea 
                  v-model="outrosMotivosExclusao"
                  outlined
                  rows="2"
                />
              </v-col>
              <v-col cols="12" class="modal-cadastro-form-col-imput">
                <v-btn
                  type="submit"
                  :color="variables.colorPrimary"
                  @click.prevent="submit"
                  class="br-btn br-btn-entity-products"
                  :loading="loading"
                  :width="70"
                  >Salvar</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
        <!-- <comissao :entity="entity" /> -->
      </div>
    </v-card>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
// import { validCnpj } from '@/core/service/utils'
// import { cnpj } from 'cpf-cnpj-validator'
import variables from '@/assets/styles/helpers/_variables.scss'

// const validCNPJ = (params) => {
//   console.log(params)
// }

export default {
  name: 'BrModalCadastroAts',
  mixins: [validationMixin],
  directives: {mask},
  components: {
    Modal: () => import('@/views/components/modal'),
    // comissao: () => import('./comissao')
  },
  props: {
    entity: {
      type: Object,
      default: () => ({
        jsonData: {
          fullName: ''
        }
      })
    },

    isActiveModal: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    search: '',
    headers: [
      { class: 'table-header', text: 'ID Produto', value: 'productId' },
      { class: 'table-header', text: 'Produto', value: 'product.name' },
      { class: 'table-header', text: 'Comissão', value: 'comission' },
      { class: 'table-header', text: 'Limite de Crédito', value: 'debtLimit' },
      { class: 'table-header', text: '', value: 'action', sortable: false },
    ],
    divider: '/',
    desserts: [],
    itemPerPage: [5, 10, 50, 100, {text: 'Todos', value: -1}],
    itemsSelectMotivoExclusao: [
      'A pedido do usuário',
      'Usuário suspeito',
      'Outros'
    ],
    motivoExclusao:'A pedido do usuário',
    outrosMotivosExclusao: '',
    loadingTable: false,
    loadingModal: false
  }),
  watch: {
  },
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('estabelecimento', ['listProducts', 'itemEntityProducts', 'listItensEntitiesPoducts']),
    
    // ...validacao,

    variables: () => variables,
    isEdit () {
      return this.itemEntityProducts.id ? !!1 : !!0
    },
    activeForm () {
      return this.itemEntityProducts.id ? !!0 : !!1
    },

    retainErrors () {
      const errors = []
      if (!this.$v.entity.jsonFlags.retainComission.$dirty) return errors
      !this.$v.entity.jsonFlags.retainComission.required && errors.push('Valor é obrigatório.')
      !this.$v.entity.jsonFlags.retainComission.minValue && errors.push('Valor minimo inválido.')
      !this.$v.entity.jsonFlags.retainComission.maxValue && errors.push('Valor maximo inválido.')
      return errors
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('estabelecimento', ['toggleReterComissao']),
    ...mapActions('estabelecimentoComissao', {
      obterItensSelectParentId: 'obterItensSelect',
    }),

    closeModal () {
      this.motivoExclusao = 'A pedido do usuário',
      this.outrosMotivosExclusao = '',
      this.$emit('close-modal', true)
    },
    cancel () {
      this.limparItemEntityProduct()
      this.$v.itemEntityProducts.$reset()
    },
    submit () {
      let isStatus = this.entity.status === 'A' ? 'deactivate' : 'activate'
      this.$swal({
        icon: 'warning',
        text: `Tem certeza que deseja alterar o status de ${this.entity.jsonData.fullName}`,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      })
      .then((result) => {
        if (result.value) {
          this.$emit('deletarUsuario', {
            entityId: this.entity.id,
            isStatus,
            motivoExclusao: this.motivoExclusao,
            outrosMotivosExclusao: this.outrosMotivosExclusao
          })
        }
      })
    },
  },

  validations () {
    return  {
      entity: {
        jsonFlags: {
          retainComission: { required, minValue: minValue(0), maxValue: maxValue(100) }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/formularios';
  .br-btn-entity-products {
    margin-top: 10px;
    min-width: auto !important;
    font-size: 0.8em !important;
  }
</style>